import styles from "./styles.module.scss";
import { Lock, StarIcon } from "@assets/Icons";
import { Button } from "@common/index";
import authService from "@api/services/authService";
import { Tooltip } from "src/routes/onboarding/shared/components/tooltip";
import fingerup from "@assets/img/emoji/fingerup.png";
import { useEmail } from "src/routes/onboarding/shared";
import { useNavigate } from "react-router";
import { trackUserEvent } from "@utils/updateDataLayer";
import { updateDataLayer } from "@utils/updateDataLayer";
import { useOnboardingTexts } from "src/routes/onboarding/shared/hooks/useOnboardingTexts";

const title = "We ask your email to create your account";
const content =
  "Protecting your privacy is a very serious matter for us. Your email is being used to create an account for you so that your data can be saved in it.";

export const Email = () => {
  const navigate = useNavigate();
  const onNextStep = () => {
    navigate("/news");
  };

  const { getSectionText } = useOnboardingTexts();

  const text = getSectionText("email").title;

  const {
    email,
    isValid,
    errorMessage,
    handleEmailChange,
    isLoading,
    onSubmit,
  } = useEmail(authService.emailOnlySignUp, async () => {
    updateDataLayer({
      event: "register_complete",
      email: email,
    });
    onNextStep();
  });

  const handleSubmit = async () => {
    trackUserEvent("", {
      screenId: "Email",
      screenTitle: text,
    });

    onSubmit(isValid, email);
  };

  return (
    <div className={styles.container} id="breakdown">
      <div className={styles.content}>
        <h2>
          Enter your email to receive
          <br />
          <span>Your Custom Program</span>
        </h2>
        <div className={styles.input}>
          <input
            placeholder="Your email"
            type="email"
            value={email}
            onChange={(e) => handleEmailChange(e.currentTarget.value)}
            className={isValid}
          />
          {errorMessage && <p className={styles.error}>{errorMessage}</p>}{" "}
          <div className={styles.hint}>
            <div>
              <Lock />
            </div>
            <p>
              We care about your privacy and are dedicated to protecting your
              personal information.
            </p>
          </div>
        </div>
      </div>
      <div className={styles.action}>
        <Button onClick={handleSubmit} disabled={!isValid || isLoading}>
          Continue
        </Button>
      </div>
    </div>
  );
};
